import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function findOrderByOptions() {
  return [
    { label: "our_choice", value: mainIndex, context: catalogContexts.swap },
    {
      label: "newest",
      value: mainIndex.replace("principal", "newest"),
      context: catalogContexts.swap,
    },
    {
      label: "our_choice",
      value: mainIndex.replace("principal", "sale"),
      context: catalogContexts.sales,
    },
    {
      label: "price",
      value: mainIndex.replace("principal", "price"),
      context: catalogContexts.sales,
    },
    {
      label: "discount",
      value: mainIndex.replace("principal", "discount"),
      context: catalogContexts.sales,
    },
  ];
}
